import React, { useState } from 'react';
import '../styles/ContactStyles/ContactPage.css';
import Header from '../components/Header';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here

  };

  return (
    <div className="contact-page">
      <Header />
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-left">
          <div className="contact-hero-content">
            <h1>Contact Us</h1>
            <p>We'd love to hear from you</p>
          </div>
        </div>
        <div className="contact-hero-right">
          <img src="/images/pourover.png" alt="Contact Grey Coffee" />
        </div>
      </section>

      {/* Contact Information */}
      <section className="contact-info">
        <div className="info-grid">
          <div className="info-card">
            <img src="/images/location.png" alt="Location" />
            <h3>Visit Us</h3>
            <p>123 Coffee Street</p>
            <p>Melbourne, VIC 3000</p>
            <p>Australia</p>
          </div>
          <div className="info-card">
            <img src="/images/phone.png" alt="Phone" />
            <h3>Call Us</h3>
            <p>+61 3 1234 5678</p>
            <p>Mon - Fri: 9am - 5pm</p>
          </div>
          <div className="info-card">
            <img src="/images/email.png" alt="Email" />
            <h3>Email Us</h3>
            <p>info@greycoffee.com</p>
            <p>wholesale@greycoffee.com</p>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="contact-form-section">
        <div className="form-container">
          <h2>Send Us a Message</h2>
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="6"
                required
              ></textarea>
            </div>
            <button type="submit" className="submit-button">
              Send Message
            </button>
          </form>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="map-container">
          <iframe
            title="Grey Coffee Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.8354345096385!2d144.9617!3d-37.8132!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDQ4JzQ3LjUiUyAxNDTCsDU3JzQyLjEiRQ!5e0!3m2!1sen!2sau!4v1234567890"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </section>

      {/* FAQ Preview */}
      <section className="faq-preview">
        <div className="faq-content">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            <div className="faq-item">
              <h3>What are your opening hours?</h3>
              <p>We're open Monday to Friday from 7am to 4pm, and weekends from 8am to 3pm.</p>
            </div>
            <div className="faq-item">
              <h3>Do you offer international shipping?</h3>
              <p>Yes, we ship to selected countries. Please contact us for more information.</p>
            </div>
            <div className="faq-item">
              <h3>How fresh is your coffee?</h3>
              <p>All our coffee is roasted to order and shipped within 24 hours of roasting.</p>
            </div>
            <div className="faq-item">
              <h3>Do you offer wholesale pricing?</h3>
              <p>Yes, please visit our wholesale page or contact our wholesale team directly.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
